import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import { createCustomer, CreateCustomerResult } from "../../api/platformCustomers";

type Props = {
  onClose: () => void;
  onCreated: (result: CreateCustomerResult) => void;
};

export function CreateCustomerModal({ onClose, onCreated }: Props) {
  const [tenantName, setTenantName] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPhone, setAdminPhone] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [branchAddress, setBranchAddress] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const name = tenantName.trim();
      // Tek lokasyon modeli: lokasyon adi = kurum adi (Musteri "Merkez" gormez).
      const result = await createCustomer({
        tenantName: name,
        branchName: name,
        adminName: adminName.trim(),
        adminEmail: adminEmail.trim(),
        adminPassword,
        adminPhone: adminPhone.trim() || undefined,
        branchAddress: branchAddress.trim() || undefined,
      });
      onCreated(result);
    } catch (err: unknown) {
      setError(err instanceof ApiError ? err.message : "Musteri olusturulamadi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kp-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="kp-card kp-customer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kp-customer-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="kp-customer-modal__head">
          <h3 id="kp-customer-modal-title">Yeni Müşteri Kurumu</h3>
          <button type="button" className="kp-btn kp-btn--ghost" onClick={onClose} disabled={busy}>
            Kapat
          </button>
        </div>

        <form className="kp-customer-modal__form" onSubmit={handleSubmit}>
          <p className="kp-muted">
            Her kayıt ayrı bir kurum oluşturur. Müşteri girişte <strong>Kurs Adı</strong> olarak kurum
            adını yazar. Standart paket otomatik uygulanır.
          </p>

          <label className="kp-customer-field">
            <span>
              Kurum adı (Kurs Adı) <em>*</em>
            </span>
            <input
              className="kp-input"
              value={tenantName}
              onChange={(e) => setTenantName(e.target.value)}
              required
              maxLength={150}
              placeholder="Örn. ÖZDAMLA UĞURMUMCU"
              disabled={busy}
            />
            <small className="kp-muted">Giriş ekranındaki Kurs Adı budur.</small>
          </label>

          <label className="kp-customer-field">
            <span>
              Yönetici ad soyad <em>*</em>
            </span>
            <input
              className="kp-input"
              value={adminName}
              onChange={(e) => setAdminName(e.target.value)}
              required
              maxLength={150}
              disabled={busy}
            />
          </label>

          <label className="kp-customer-field">
            <span>
              Yönetici e-posta <em>*</em>
            </span>
            <input
              className="kp-input"
              type="email"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              required
              maxLength={150}
              disabled={busy}
            />
          </label>

          <label className="kp-customer-field">
            <span>Telefon</span>
            <input
              className="kp-input"
              value={adminPhone}
              onChange={(e) => setAdminPhone(e.target.value)}
              maxLength={30}
              disabled={busy}
            />
          </label>

          <label className="kp-customer-field">
            <span>
              Geçici parola <em>*</em>
            </span>
            <input
              className="kp-input"
              type="text"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              required
              minLength={8}
              maxLength={128}
              placeholder="En az 8 karakter"
              disabled={busy}
            />
            <small className="kp-muted">Müşteriye iletin; ilk girişte şifre değiştirmesi istenir.</small>
          </label>

          <label className="kp-customer-field">
            <span>Adres</span>
            <input
              className="kp-input"
              value={branchAddress}
              onChange={(e) => setBranchAddress(e.target.value)}
              maxLength={400}
              disabled={busy}
            />
          </label>

          {error && <div className="kp-customer-modal__error">{error}</div>}

          <div className="kp-customer-modal__actions">
            <button type="button" className="kp-btn" onClick={onClose} disabled={busy}>
              İptal
            </button>
            <button type="submit" className="kp-btn kp-btn--primary" disabled={busy}>
              {busy ? "Oluşturuluyor…" : "Müşteriyi Oluştur"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
